import { render, staticRenderFns } from "./SettingsSubpage.vue?vue&type=template&id=51ea5f18&"
import script from "./SettingsSubpage.vue?vue&type=script&lang=js&"
export * from "./SettingsSubpage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSubpage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports